module.exports = __webpack_public_path__ + "img/img-4.26e60442.webp";